import { PERSONAL_EMAIL_DOMAINS } from "@/shared/constants";

export type EmailType = "work" | "generic" | "none";

/**
 * Classifies an email for the signup funnel's `email type` dimension:
 * - `work` — a business domain (not a personal/free provider)
 * - `generic` — a valid personal/free-provider address (gmail, outlook, …)
 * - `none` — missing or malformed
 *
 * Kept in the analytics feature (not how-to-start) so both the auth flow and
 * the funnel can classify without a cross-feature dependency.
 */
export const getEmailType = (email?: string | null): EmailType => {
  if (!email) return "none";
  const parts = email.trim().split("@");
  if (parts.length !== 2 || !parts[0] || !parts[1]) return "none";
  const domain = parts[1].trim().toLowerCase();
  const labels = domain.split(".");
  if (labels.length < 2 || labels.some((label) => !label)) return "none";
  return PERSONAL_EMAIL_DOMAINS.has(domain) ? "generic" : "work";
};
